import React, {useEffect} from 'react';
import { Field } from 'react-final-form';
import Grid from "@material-ui/core/Grid";
import { Trans } from "../utils/i18n";
import RadioBigWithAmount from "./RadioBigWithAmount";
import {hasProducts} from "../config/orderEntryEnfore";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";

export const ProductSelectWithAmount = React.memo(function ({ product, form, productValues, hideProductDetailsButton = false, hideUnavailableContactLink = false }) {
        const orderEntryDispatch = useFormStateDispatch();
        const { products } = useFormState();

        useEffect(() => {
            fetch(route("order.products"))
                .then(response => response.json())
                .then(response => {
                    if(!response.success) {
                        throw 'error';
                    }
                    orderEntryDispatch({ type: 'setProducts', value: response.products });
                })

        }, []);

        if (!products) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        return (
            <div>
                <Grid container spacing={3}>
                    {
                        products
                            .map((item) =>
                                <Grid item xs={12} sm={4} key={item.id}>
                                    <Field
                                        name={`products.product_id_${item.id}`}
                                        type={'text'}
                                        //placeholder={field.placeholder}
                                        component={RadioBigWithAmount}
                                        validate={value => (hasProducts(productValues) ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                                        field={{
                                            titel: item.description,
                                            price: item.price,
                                            image: item.image,
                                            hideProductDetailsButton,
                                            hideUnavailableContactLink,
                                        }}
                                    />
                                </Grid>,
                            )
                    }
                </Grid>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

